import { Placeholder } from '@/tools/models/class-builder.models';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Inject, Prop, Watch } from 'vue-property-decorator';
import { ClassScheduleProvider } from '../class-schedule.provider';

@Component({
  name: 'ed-class-builder-sidebar',
  components: {
    EdClassSubjectPlaceholderItem: () => import(/* "EdClassSubjectPlaceholderItem" */ '../ed-class-subject-placeholder-item/ed-class-subject-placeholder-item.component.vue'),
  }
})
export default class EdClassBuilderSidebarComponent extends Vue {
  @Prop({ required: true }) readonly isSidebarOpen: boolean;
  @Prop({ required: true }) readonly allowTeachersToEdit: boolean;
  @Prop({ required: true }) readonly isAbleToEdit: boolean;

  @Inject()
  ScheduleProvider: ClassScheduleProvider;

  allowTeacherToEdit = false;

  @Emit('onAddSubjectSelected')
  emitOnAddSubjectSelected() {
    return false;
  }

  @Emit('onDeletePlaceholderSelected')
  emitOnDeletePlaceholderSelected (placeholder: Placeholder): Placeholder {
    return placeholder;
  }

  @Emit('onEditPlaceholderSelected')
  emitOnEditPlaceholderSelected (placeholder: Placeholder): Placeholder {
    return placeholder;
  }

  @Emit('onContinue')
  emitOnContinue() {
    return this.allowTeacherToEdit;
  }

  @Emit('onSeePlaceholderSelectedOnCalendar')
  emitOnSeePlaceholderSelectedOnCalendar(placeholder: Placeholder): Placeholder {
    return placeholder;
  }

  @Emit('onToggleSidebar')
  emitOnToggleSidebar() {
    return !this.isSidebarOpen;
  }

  get isTeacher(): boolean{
    return this.$store.state.AuthStore.user.role === 'TEACHER';
  }

  get placeholders(): Placeholder[] {
    return this.ScheduleProvider.subjectsAdded;
  }

  @Watch('allowTeachersToEdit')
  onAllowTeachersToEditChanged(value: boolean) {
    this.allowTeacherToEdit = value;
  }
}